import moment from 'moment';
import dayjs from 'dayjs';

import { NEW_FORMAT } from 'constants/date-constants';

export function isBankHoliday({ totemClosedDays, date }: { totemClosedDays: string[]; date: string | Date }): boolean {
    return totemClosedDays.includes(moment(date).format(NEW_FORMAT));
}

export function isDateBeforeNext(date: string | Date, nextDate: string | Date): boolean {
    return date < nextDate;
}

export function isWeekEnd(date: string | Date): boolean {
    return ['6', '0'].includes(dayjs(date).format('d'));
}

export function getInitialVisibleMonth({
    selectedDate,
    nextDeliveryDate,
}: {
    selectedDate: moment.Moment | null;
    nextDeliveryDate: string | Date | moment.Moment | dayjs.Dayjs;
}): moment.Moment {
    if (selectedDate) return selectedDate;
    // If nextDeliveryDate is a moment object, return as is
    if (moment.isMoment(nextDeliveryDate)) return nextDeliveryDate;
    // If nextDeliveryDate is a dayjs object, convert to moment
    if (dayjs.isDayjs(nextDeliveryDate)) return moment(nextDeliveryDate.toDate());
    // If nextDeliveryDate is a string or Date, parse with moment
    return moment(nextDeliveryDate);
}
